import React, {Component} from 'react'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell';
import styles from "./BaseTableRowCollapse.module.scss";
import Collapse from '@mui/material/Collapse';

class BaseTableRowCollapse extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <TableRow className={styles.tableRow}>
                <TableCell colSpan={this.props.totalColumns} className={styles.tableCell}>
                    <Collapse in={this.props.isCollapseOpen} timeout="auto" unmountOnExit className={styles.collapse}>
                        {this.props.content}
                    </Collapse>
                </TableCell>
            </TableRow>
        )
    }
}

export default BaseTableRowCollapse